import { useEffect } from 'react';

interface UseEmployeeWorkScheduleActionModalEffectsParams {
  syncFormAndCheckScheduleConflicts: () => void;
}
export const useEmployeeWorkScheduleActionModalEffects = ({
  syncFormAndCheckScheduleConflicts,
}: UseEmployeeWorkScheduleActionModalEffectsParams) => {
  useEffect(() => {
    syncFormAndCheckScheduleConflicts();
  }, [syncFormAndCheckScheduleConflicts]);
};
